;(function() {
  'use strict'

  Controller.$inject = ["locationService", "elementService"];
  angular.module('app.survey').component('surveyQuestionPlace', {
    controller: Controller,
    templateUrl: 'survey-question-place.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(locationService, elementService) {
    var ctrl = this

    var searchRequestNum = 0
    var data

    ctrl.$onInit = onInit
    ctrl.beginSearch = beginSearch
    ctrl.doSearch = doSearch
    ctrl.doSearchDebounced = _.debounce(doSearch, 700)
    ctrl.clearSelectedPlaces = clearSelectedPlaces

    function onInit() {
      var query = ctrl.survey.injectValues(
        ctrl.question.placesSearchTermsPipes,
        ctrl.question.loopKey
      )

      // resume the stored state ONLY if the query didnt change from pipes
      if (ctrl.question.data && ctrl.question.data.query === query) {
        data = ctrl.question.data
        return
      }

      ctrl.question.data = data = {}
      data.query = query

      var locationAllowed = locationService.isAllowed()
      if (locationAllowed === true || locationAllowed === false) {
        data.state = 'list'
        doSearch()
      } else {
        data.state = 'prompt'
      }
    }

    function beginSearch(useLocation) {
      if (useLocation) {
        data.state = 'loading'
        locationService
          .get(true)
          .then(doSearch)
          .catch(doSearch)
      } else {
        doSearch()
      }
    }

    function doSearch() {
      data.state = 'loading'

      searchRequestNum++
      var thisRequest = _.clone(searchRequestNum)

      data.places = null
      data.showMore = false

      var options = {
        subscriberId: ctrl.question.placesSubscriberId,
      }
      options.types = data.query ? ['place'] : ['near']

      locationService
        .get()
        .then(go)
        .catch(go)

      function go() {
        elementService.search(data.query, 30, options).then(
          function(results) {
            // cancel if user stopped, or new request has begun
            if (thisRequest !== searchRequestNum) {
              return
            }
            data.places = results.all
            data.state = results.all.length > 0 ? 'ready' : 'none'
          },
          function() {
            data.state = 'error'
            console.error('survey places near me search error')
          }
        )
      }
    }

    function clearSelectedPlaces() {
      ctrl.question.selected.length = 0
    }
  }
})()
